import { render, staticRenderFns } from "./HouseholdIncomes.vue?vue&type=template&id=19ba519a&scoped=true&"
import script from "./HouseholdIncomes.vue?vue&type=script&lang=js&"
export * from "./HouseholdIncomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba519a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ba519a')) {
      api.createRecord('19ba519a', component.options)
    } else {
      api.reload('19ba519a', component.options)
    }
    module.hot.accept("./HouseholdIncomes.vue?vue&type=template&id=19ba519a&scoped=true&", function () {
      api.rerender('19ba519a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/HouseholdIncomes.vue"
export default component.exports